import api from './axiosInstance';
export const getAll = (params) => api.get('/material-groups', { params });
export const getById = (id) => api.get(`/material-groups/${id}`);
export const create = (data) => api.post('/material-groups', data);
export const update = (id, data) => api.put(`/material-groups/${id}`, data);
export const remove = (id) => api.delete(`/material-groups/${id}`);
export const batchRemove = (ids) => api.post('/material-groups/batch-delete', { ids });
